import { ArrowRight } from "lucide-react";
import { Eyebrow, IMAGES, Reveal } from "./shared";

const SUPPORT = [
    "International admission pathways",
    "Scholarship discovery and application guidance",
    "Student visa documentation support",
];

export const StudyAbroad = () => (
    <section id="study-abroad" data-testid="study-abroad-section" className="bg-ivory py-24 lg:py-32">
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <div className="grid items-center gap-12 lg:grid-cols-12 lg:gap-16">
                <Reveal className="lg:col-span-7">
                    <div className="group overflow-hidden">
                        <img
                            src={IMAGES.study}
                            alt="A young student walking through a university district"
                            loading="lazy"
                            className="aspect-[16/11] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                        />
                    </div>
                </Reveal>
                <Reveal delay={0.15} className="lg:col-span-5">
                    <Eyebrow>Study Abroad</Eyebrow>
                    <h2 className="mt-5 font-serif text-3xl font-medium tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        Your Education. Your Future. The World.
                    </h2>
                    <p className="mt-6 text-base leading-relaxed text-ink/65">
                        We help students explore international education opportunities — from choosing the
                        right pathway to preparing a strong application and navigating the student visa
                        process.
                    </p>
                    <ul className="mt-8 space-y-4">
                        {SUPPORT.map((line) => (
                            <li key={line} className="flex items-start gap-4 text-sm text-ink/75">
                                <span className="mt-2 h-px w-6 shrink-0 bg-champagne" aria-hidden="true" />
                                {line}
                            </li>
                        ))}
                    </ul>
                    <a
                        href="#contact"
                        data-testid="study-abroad-explore-btn"
                        className="mt-10 inline-flex items-center gap-2 bg-forest px-8 py-4 text-sm font-medium text-ivory transition-colors hover:bg-forest-deep"
                    >
                        Explore Study Abroad
                        <ArrowRight size={16} strokeWidth={1.5} />
                    </a>
                </Reveal>
            </div>
        </div>
    </section>
);
